export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const ACCESS_TOKEN_EXPIRY_SECONDS = 900; // 15 minutes
export const REFRESH_TOKEN_EXPIRY_SECONDS = 604800; // 7 days
export const REFRESH_TOKEN_ABSOLUTE_MAX_SECONDS = 2592000; // 30 days
export const IDLE_TIMEOUT_SECONDS = 1800; // 30 minutes
export const MAX_CONCURRENT_SESSIONS = 5;
export const MFA_BACKUP_CODE_COUNT = 10;
export const BCRYPT_COST_FACTOR = 12;
export const PASSWORD_HISTORY_COUNT = 10;

/** Progressive lockout durations in minutes */
export const LOCKOUT_THRESHOLDS = [
  { attempts: 3, durationMinutes: 1 },
  { attempts: 5, durationMinutes: 5 },
  { attempts: 8, durationMinutes: 15 },
  { attempts: 10, durationMinutes: 60 },
  { attempts: 15, durationMinutes: -1 }, // -1 = permanent (requires admin unlock)
] as const;
